import { useEffect } from 'react';
import NoResultsWrapper from 'Pages/NoResultsWrapper';
import router from 'next/router';
import api from '../api';
import getBuildTime from '../services/build/getBuildTime';
import getInitialReduxState from '../services/page/getInitialReduxState';

export default function Home(props) {
   useEffect(() => {
      router.push('/no-hay-resultados');
   });
   return <NoResultsWrapper title="No hay resultados" {...props} />;
}
export async function getStaticProps(context, storeId = process.env.NEXT_PUBLIC_STORE_ID) {
   const startTime = new Date();
   const initialReduxState = await getInitialReduxState(storeId);
   const promotedProducts = await api.products.getPromotedProducts(storeId);
   const brands = await api.brands.get(storeId);

   if (!brands.success) {
      throw new Error(brands.error);
   }

   if (!promotedProducts.success) {
      throw new Error(promotedProducts.error);
   }

   return {
      props: {
         initialReduxState,
         promotedProducts: promotedProducts.data,
         brands: brands.data,
         buildInfo: {
            generatedAt: startTime.toLocaleTimeString(),
            execTime: getBuildTime(startTime),
            path: '/no-hay-resultados',
         },
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once 5 second
      revalidate: 10, // In seconds
   };
}
